export interface TrackItem {
  name: string;
  duration: string;
}

export interface WorkItem {
  id: string;
  title: string;
  category: "movie" | "music";
  type: "电影" | "电视剧" | "单曲" | "专辑";
  year: number;
  cover: string;
  role: string;
  director: string;
  region: string;
  summary: string;
  description: string[];
  tracks?: TrackItem[];
}

export const worksList: WorkItem[] = [
  {
    id: "work-m1",
    title: "静默之城",
    category: "movie",
    type: "电影",
    year: 2026,
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20style%20photograph%20of%20a%20solitary%20silhouette%20against%20a%20misty%20deep%20navy%20city%20skyline%20at%20dusk%20with%20warm%20amber%20window%20lights%2C%20minimal%20elegant%20composition%2C%20high%20detail%2C%20moody%20mysterious%20atmosphere&width=600&height=800&seq=movie-01&orientation=portrait",
    role: "主演 · 饰 林知夏",
    director: "高桥和也",
    region: "日本",
    summary: "一位调查记者在喧嚣都市中追踪一桩尘封旧案，真相与记忆在静默中缓缓浮出水面。",
    description: [
      "《静默之城》是一部以都市悬疑为外壳、以记忆与真相为内核的电影。森泽佳奈在片中饰演调查记者林知夏，因一次偶然的线索卷入多年前的旧案。",
      "影片以克制的叙事节奏展开，城市的声音被刻意弱化，取而代之的是人物细密的心理变化。森泽佳奈的表演以微表情与沉默见长，被评价为「安静却极具张力」。",
      "导演高桥和也表示，选择森泽佳奈正是因为她的气质中兼具锋利与柔软，能够承载角色复杂的内心层次。",
      "影片摄影以深蓝色调为主，配合暖橙色的零星光源，形成鲜明的视觉对比，强化了「在冷漠中寻找温度」的主题。",
    ],
  },
  {
    id: "work-m2",
    title: "樱花下的约定",
    category: "movie",
    type: "电视剧",
    year: 2025,
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20series%20poster%20style%20photograph%20of%20soft%20pink%20blossoms%20drifting%20over%20a%20quiet%20traditional%20street%20with%20deep%20navy%20dusk%20sky%20and%20warm%20amber%20lantern%20light%2C%20minimal%20elegant%20composition%2C%20high%20detail%2C%20gentle%20nostalgic%20mood&width=600&height=800&seq=movie-02&orientation=portrait",
    role: "主演 · 饰 佐仓澪",
    director: "小林由美",
    region: "日本",
    summary: "一次跨越十年的重逢，让两个曾经错过的人重新审视关于成长的约定。",
    description: [
      "《樱花下的约定》是一部聚焦成长与遗憾的都市情感剧。森泽佳奈饰演的佐仓澪在十年后回到故乡，与少年时代的伙伴重逢。",
      "剧集以四季为章节结构，用细腻的日常描写串联起人物的情感变化。森泽佳奈在其中的表演被观众形容为「像春天一样温柔」。",
      "为呈现真实的季节质感，剧组跨越多个地区实景拍摄，樱花、夏雨、秋叶与冬雪成为叙事的重要一部分。",
    ],
  },
  {
    id: "work-m3",
    title: "远山的回声",
    category: "movie",
    type: "电影",
    year: 2024,
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20style%20photograph%20of%20layered%20misty%20mountains%20at%20blue%20hour%20with%20warm%20amber%20sunlight%20breaking%20through%2C%20deep%20navy%20tones%2C%20minimal%20elegant%20composition%2C%20high%20detail%2C%20serene%20majestic%20mood&width=600&height=800&seq=movie-03&orientation=portrait",
    role: "主演 · 饰 森川遥",
    director: "中村慎一",
    region: "日本",
    summary: "一位城市女孩回到山村处理旧宅，在群山之间重新找回了与家人的连接。",
    description: [
      "《远山的回声》以山村生活为背景，讲述森泽佳奈饰演的森川遥在回到故乡后，逐渐理解父辈选择的温情故事。",
      "影片强调人与自然的相处，大量镜头在自然光下完成，呈现出质朴而辽阔的视觉风格。",
      "森泽佳奈为角色学习了农作与山间徒步等生活技能，她表示这次拍摄让自己「第一次真正慢了下来」。",
    ],
  },
  {
    id: "work-m4",
    title: "霓虹深处",
    category: "movie",
    type: "电视剧",
    year: 2023,
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20series%20poster%20style%20photograph%20of%20a%20rainy%20neon%20city%20street%20reflecting%20deep%20navy%20blue%20and%20warm%20amber%20lights%2C%20minimal%20elegant%20composition%2C%20high%20detail%2C%20moody%20urban%20atmosphere&width=600&height=800&seq=movie-04&orientation=portrait",
    role: "主演 · 饰 藤井玲",
    director: "佐藤健吾",
    region: "日本",
    summary: "在灯红酒绿的城市夜色中，一位年轻记者试图揭开光鲜表面之下的真实。",
    description: [
      "《霓虹深处》以都市夜生活为舞台，森泽佳奈饰演的年轻记者藤井玲在采访中逐渐接近一个被隐藏的真相。",
      "剧集以强烈的视觉风格著称，霓虹色彩与深蓝色夜景交织，营造出既迷人又疏离的氛围。",
      "森泽佳奈在剧中的造型与表演突破以往形象，被评价为「更具锋芒的一次演绎」。",
    ],
  },
  {
    id: "work-m5",
    title: "夏日信笺",
    category: "movie",
    type: "电影",
    year: 2022,
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20style%20photograph%20of%20a%20sunlit%20seaside%20town%20with%20gentle%20waves%20and%20deep%20navy%20sky%20at%20golden%20hour%2C%20warm%20amber%20tones%2C%20minimal%20elegant%20composition%2C%20high%20detail%2C%20nostalgic%20summer%20mood&width=600&height=800&seq=movie-05&orientation=portrait",
    role: "主演 · 饰 有森夏帆",
    director: "山田信之",
    region: "日本",
    summary: "一个夏天、一封未寄出的信，串起了青春里最珍贵的记忆。",
    description: [
      "《夏日信笺》是一部青春成长题材电影，讲述森泽佳奈饰演的有森夏帆在海边小镇度过的一个夏天。",
      "影片以信件作为叙事线索，将回忆与现实交错呈现，充满怀旧与温暖的气息。",
      "森泽佳奈的表演自然细腻，成为许多观众心中的青春记忆代表作。",
    ],
  },
  {
    id: "work-m6",
    title: "雾都纪事",
    category: "movie",
    type: "电视剧",
    year: 2021,
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20series%20poster%20style%20photograph%20of%20a%20foggy%20historic%20city%20street%20with%20deep%20navy%20mist%20and%20warm%20amber%20streetlamp%20glow%2C%20minimal%20elegant%20composition%2C%20high%20detail%2C%20atmospheric%20mysterious%20mood&width=600&height=800&seq=movie-06&orientation=portrait",
    role: "特别出演 · 饰 神秘女子",
    director: "木村达也",
    region: "日本",
    summary: "在雾气弥漫的旧城里，一段被遗忘的往事悄然浮现。",
    description: [
      "《雾都纪事》是一部带有年代感的悬疑剧集，森泽佳奈以特别出演身份登场，饰演贯穿全剧的关键人物。",
      "尽管戏份不多，但她的出场成为全剧的重要转折点，被观众称为「一抹神秘的光」。",
      "剧集以厚重的氛围营造与精巧的结构获得好评。",
    ],
  },
  {
    id: "work-s1",
    title: "潮汐",
    category: "music",
    type: "专辑",
    year: 2026,
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20album%20cover%20art%20of%20deep%20navy%20ocean%20waves%20meeting%20a%20warm%20amber%20glowing%20horizon%2C%20abstract%20minimal%20elegant%20composition%2C%20soft%20grain%2C%20high%20detail%2C%20refined%20artistic%20mood&width=600&height=600&seq=music-01&orientation=squarish",
    role: "演唱 / 词曲创作",
    director: "森泽佳奈 × 长谷川制作",
    region: "数字发行",
    summary: "以海洋与光影为线索的第三张个人专辑，收录十首全新作品。",
    description: [
      "《潮汐》是森泽佳奈的第三张个人专辑，围绕海洋、光影与时间三个主题展开，是她音乐表达能力最完整的一次呈现。",
      "专辑由森泽佳奈亲自参与词曲创作，主打曲以钢琴与弦乐铺陈，情绪辽阔而克制。",
      "专辑视觉以深蓝与暖橙的对比色调呈现潮起潮落的意象，强调「缓慢而坚定的力量」。",
    ],
    tracks: [
      { name: "潮汐", duration: "04:12" },
      { name: "海面上的信", duration: "03:48" },
      { name: "光影之间", duration: "04:05" },
      { name: "退潮以后", duration: "03:32" },
      { name: "灯塔", duration: "04:21" },
      { name: "蓝色回声", duration: "03:57" },
      { name: "潮线", duration: "04:44" },
      { name: "夜色航行", duration: "03:40" },
      { name: "归港", duration: "04:15" },
      { name: "远方的光", duration: "05:02" },
    ],
  },
  {
    id: "work-s2",
    title: "晚风",
    category: "music",
    type: "单曲",
    year: 2026,
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20single%20cover%20art%20of%20flowing%20sheer%20fabric%20in%20the%20evening%20breeze%20with%20deep%20navy%20and%20warm%20amber%20light%2C%20abstract%20minimal%20elegant%20composition%2C%20soft%20grain%2C%20high%20detail%2C%20serene%20artistic%20mood&width=600&height=600&seq=music-02&orientation=squarish",
    role: "演唱 / 词曲创作",
    director: "森泽佳奈 × 岛田编曲",
    region: "数字发行",
    summary: "首次尝试轻电子与民谣融合的编曲方向，带来清爽的夏日听觉体验。",
    description: [
      "《晚风》是森泽佳奈首次尝试将轻电子元素与民谣编曲融合的作品，以简约吉他律动为基底。",
      "歌曲勾勒出夏夜微风的画面感，是她写给每一个在夏日夜晚散步的人。",
      "单曲配套发布以自然光影为主题的视觉影像。",
    ],
    tracks: [{ name: "晚风", duration: "03:36" }],
  },
  {
    id: "work-s3",
    title: "城市之光",
    category: "music",
    type: "专辑",
    year: 2025,
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20album%20cover%20art%20of%20softly%20blurred%20city%20lights%20at%20night%20in%20deep%20navy%20blue%20with%20warm%20amber%20bokeh%2C%20abstract%20minimal%20elegant%20composition%2C%20soft%20grain%2C%20high%20detail%2C%20dreamy%20artistic%20mood&width=600&height=600&seq=music-03&orientation=squarish",
    role: "演唱 / 词曲创作",
    director: "森泽佳奈 × 长谷川制作",
    region: "数字发行",
    summary: "第二张个人专辑，以都市夜景为灵感，记录温暖与孤独交织的瞬间。",
    description: [
      "《城市之光》是森泽佳奈的第二张专辑，灵感来自她在城市生活中的观察与感受。",
      "专辑在编曲上更为丰富，融合电子、弦乐与钢琴元素，展现了她在音乐上的成长。",
      "同名主打曲成为她早期现场演出中的常驻曲目。",
    ],
    tracks: [
      { name: "城市之光", duration: "04:08" },
      { name: "深夜电台", duration: "03:52" },
      { name: "天台风", duration: "04:19" },
      { name: "霓虹散步", duration: "03:44" },
      { name: "未寄出的信", duration: "04:36" },
      { name: "黎明前", duration: "04:01" },
      { name: "回家路上", duration: "03:58" },
      { name: "光的形状", duration: "04:27" },
    ],
  },
  {
    id: "work-s4",
    title: "星空回响",
    category: "music",
    type: "单曲",
    year: 2024,
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20single%20cover%20art%20of%20a%20deep%20navy%20starry%20night%20sky%20with%20warm%20amber%20shooting%20star%20streaks%2C%20abstract%20minimal%20elegant%20composition%2C%20soft%20grain%2C%20high%20detail%2C%20dreamy%20cosmic%20mood&width=600&height=600&seq=music-04&orientation=squarish",
    role: "演唱 / 词曲创作",
    director: "森泽佳奈 × 岛田编曲",
    region: "数字发行",
    summary: "一首关于仰望星空的抒情单曲，献给所有怀揣愿望的人。",
    description: [
      "《星空回响》是一首抒情单曲，以星空为意象，讲述愿望与坚持的主题。",
      "歌曲以钢琴为主奏，配合渐进的弦乐编排，情绪层层递进。",
      "森泽佳奈表示，这首歌写给所有在夜里依然相信明天的人。",
    ],
    tracks: [{ name: "星空回响", duration: "04:24" }],
  },
  {
    id: "work-s5",
    title: "海边的房间",
    category: "music",
    type: "专辑",
    year: 2023,
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20album%20cover%20art%20of%20a%20minimal%20room%20by%20the%20sea%20with%20deep%20navy%20shadows%20and%20warm%20amber%20sunlight%20through%20a%20window%2C%20abstract%20elegant%20composition%2C%20soft%20grain%2C%20high%20detail%2C%20calm%20nostalgic%20mood&width=600&height=600&seq=music-05&orientation=squarish",
    role: "演唱 / 词曲创作",
    director: "森泽佳奈 × 长谷川制作",
    region: "数字发行",
    summary: "首张个人专辑，记录一段安静独处的时光。",
    description: [
      "《海边的房间》是森泽佳奈的首张个人专辑，灵感来自她独自在海边生活的一段时光。",
      "专辑风格简约而真诚，以钢琴、吉他与环境音构建出安静的空间感。",
      "这张专辑让她在听众心中留下了「安静而有力量」的印象。",
    ],
    tracks: [
      { name: "海边的房间", duration: "04:02" },
      { name: "午后", duration: "03:41" },
      { name: "旧相机", duration: "03:55" },
      { name: "窗外", duration: "04:13" },
      { name: "第一封信", duration: "03:38" },
      { name: "安静的海", duration: "04:29" },
    ],
  },
  {
    id: "work-s6",
    title: "初见",
    category: "music",
    type: "单曲",
    year: 2022,
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20single%20cover%20art%20of%20a%20soft%20dawn%20horizon%20in%20deep%20navy%20and%20warm%20amber%20gradient%2C%20abstract%20minimal%20elegant%20composition%2C%20soft%20grain%2C%20high%20detail%2C%20gentle%20hopeful%20mood&width=600&height=600&seq=music-06&orientation=squarish",
    role: "演唱 / 词曲创作",
    director: "森泽佳奈 × 岛田编曲",
    region: "数字发行",
    summary: "森泽佳奈的首支公开发行单曲，一切故事的开始。",
    description: [
      "《初见》是森泽佳奈首次公开发行的单曲，也是她音乐道路的起点。",
      "歌曲以简单的旋律与真挚的情感打动听众，奠定了她创作风格的基调。",
      "多年后回顾，森泽佳奈形容这首歌是「写给未来的第一句话」。",
    ],
    tracks: [{ name: "初见", duration: "03:47" }],
  },
];